

$(document).ready(function () {

    $(window).trigger('resize.boxHeightCalc');

    /* Slider */

    $('.slick').slick({
        fade: true,
        infinite: true,
        dots: false,
        arrows: true,
        adaptiveHeight: false,
        appendArrows: $('.arrow-container')
    });

    var $slider = $('.slider');

    if ($slider.length && $('.slick-item').length > 1) {
        var currentSlide;
        var slidesCount;
        var sliderCounter = $('.slider__counter');

        var updateSliderCounter = function(slick, currentIndex) {
            currentSlide = slick.slickCurrentSlide() + 1;
            slidesCount = $('.slick-item').length;

            $(sliderCounter).text(currentSlide + '/' +slidesCount)
        };

        $slider.on('init', function(event, slick) {
            updateSliderCounter(slick);
        });

        $slider.on('afterChange', function(event, slick, currentSlide) {
            updateSliderCounter(slick, currentSlide);
        });

        $slider.slick();
    }

    $('.slick .slick-prev').on('click', function(){
        $('.slick').slick("slickPrev");
    });

    $('.slick .slick-next').on('click', function(){
        $('.slick').slick("slickNext");
    });

    /* Navigation */

    var navBarCollapse = $('#navbarNavDropdown');

    navBarCollapse.on('show.bs.collapse', function () {
        $('body').addClass('no-scroll');
    });

    navBarCollapse.on('hidden.bs.collapse', function () {
        $('body').removeClass('no-scroll');
    });

/*    $('input[type="checkbox"].project_check').click(function() {
        var inputValue = $(this).attr("name");
        $('article.simple[data-projects*="' + inputValue + '"]').fadeIn();
        console.log(inputValue);
    });
    */

/*    $('input[type="checkbox"].project_check').each(function() {
        var filter = $(this).attr("name");
        var item = $('article.simple[data-projects*="' + filter + '"]');
        console.log(item);

        $(this).click(function() {
            $(this).is(":checked") ? item.show().addClass('JA') : item.hide().addClass('NOPE');
        });
    });
*/

    /* Object Fit Polyfill */
    objectFitImages('.img-fit');

    /* Sticky Polyfill */
    var elements = $('.sticky-item');
    Stickyfill.add(elements);

    stickyHeight();

    $('.hero-1').hover(function() {
        $('#hero-1').fadeIn();
    }, function() {
        $('#hero-1').fadeOut();
    });

    $('.hero-2').hover(function() {
        $('#hero-2').fadeIn();
    }, function() {
        $('#hero-2').fadeOut();
    });

    $('.hero-3').hover(function() {
        $('#hero-3').fadeIn();
    }, function() {
        $('#hero-3').fadeOut();
    });

    $('.hero-4').hover(function() {
        $('#hero-4').fadeIn();
    }, function() {
        $('#hero-4').fadeOut();
    });

    $('#contact-bubbles .btn-icon').click(function(e) {
        e.preventDefault();
        $(this).parents('.btn-contact').toggleClass('active');
    });

    $('.project_types .project_check').on('change', function () {
        var projectTypes = [];
        $('.project_types .project_check').each(function () {
            if ($(this).prop('checked')) {
                projectTypes.push(parseInt($(this).prop('name')));
            }
        });
        filterProjects(projectTypes);
        setTimeout(stickyHeight,1000);
    });

    if ($("form[id^='contact']").length) {
        $("form[id^='contact'] div.actions").insertAfter($("textarea[id$='textarea-1']").parent().parent());
    }

});

function stickyHeight() {
    if ($('body#startpage').length) {
        var contentHeight = $('section#content').height();
    } else {
        var contentHeight = $('section#content').outerHeight(true) + $('header#header').height();
    }

    var stickyWrapper = $('.sticky-wrapper');

    stickyWrapper.height(contentHeight);
}


$(window).on('resize.boxHeightCalc', function() {

    if ($(window).width() > 767) {

        var maxHeight = 0,
            parentRow = $('.frame-type-menu_pages').parents('.row');

        parentRow.each(function () {
            var item = $(this).find('.teaser-overview');

            item.each(function () {
                if ($(this).height() > maxHeight) {
                    maxHeight = $(this).height();
                }
            });

            item.height(maxHeight);
        });

    }
    if ($(window).width() > 575) {
        var maxHeightCustomer = 0;
        var customerBox = $('.frame-type-menu_subpages .customer');
        customerBox.each(function () {
                var body = $(this).find("a");

                if (body.height() > maxHeightCustomer) {
                    maxHeightCustomer = body.height();
                }
            }

        );
        customerBox.find("a").height(maxHeightCustomer);

    }

});

function filterProjects(projectTypes) {
    $simple = $('.simple');

    if ($simple.length === 0) {
        return;
    }

    $simple.show();


    if (projectTypes.length === 0) {
        return;
    }

    $simple.each(function () {
        var ids = getProjects($(this).data('projects'));

        for (var i in ids) {
            for (var j in projectTypes) {
                if (ids[i] === projectTypes[j]) {
                    return;
                }
            }
        }

        $(this).fadeOut();
    });
}

function getProjects(idsAsString) {
    idsAsString = String(idsAsString);
    if (idsAsString === '') {
        return [];
    }

    var ids = idsAsString.split(',');

    for (var i in ids) {
        ids[i] = parseInt(ids[i]);
    }

    return ids;
}

function initMap() {
    var $map = $('#map'),
        zoom = 20;

    if ($map.length === 0) {
        return;
    }

    var markerPosition = {lat: 48.249428, lng: 16.338423};

    if ($map.attr('data-marker-lat') && $map.attr('data-marker-lng')) {
        markerPosition = {lat: parseFloat($map.attr('data-marker-lat')), lng: parseFloat($map.attr('data-marker-lng'))};
    }

    if ($map.attr('data-zoom')) {
        zoom = parseInt($map.attr('data-zoom'));
    }

    var map = new google.maps.Map(document.getElementById('map'), {
        zoom: zoom,
        center: markerPosition,
        styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#46bcec"},{"visibility":"on"}]}]
    });
    var markerOptions = {
        position: markerPosition,
        map: map
    };

    if ($map.attr('data-marker-image')) {
        markerOptions['icon'] = $map.attr('data-marker-image');
    }

    new google.maps.Marker(markerOptions);
}